import axios from 'axios';

const API_URL = `${process.env.REACT_APP_API_URL}/api` || 'http://localhost:5000';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Handle unauthorized responses
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const invoiceAPI = {
  getAll: () => api.get('/invoices'),
  getById: (id) => api.get(`/invoices/${id}`),
  create: (data) => api.post('/invoices', data),
  update: (id, data) => api.put(`/invoices/${id}`, data),
  delete: (id) => api.delete(`/invoices/${id}`),
  toggleStatus: (id) => api.put(`/invoices/${id}/toggle-status`),
  addCollaborator: (data) => api.post('/invoices/collaborator', data),
  removeCollaborator: (id) => api.delete(`/invoices/collaborator/${id}`),
  updateCollaborator: (id, data) => api.put(`/invoices/collaborator/${id}`, data)
};

export const collaboratorAPI = {
  getAll: () => api.get('/collaborators'),
  getById: (id) => api.get(`/collaborators/${id}`),
  create: (data) => api.post('/collaborators', data),
  update: (id, data) => api.put(`/collaborators/${id}`, data),
  delete: (id) => api.delete(`/collaborators/${id}`),
  addDeposit: (id, data) => api.post(`/collaborators/${id}/deposits`, data),
  updateDeposit: (id, depositId, data) => api.put(`/collaborators/${id}/deposits/${depositId}`, data),
  deleteDeposit: (id, depositId) => api.delete(`/collaborators/${id}/deposits/${depositId}`)
};

export default api;
